import React, { useState } from 'react'
import moment from 'moment-timezone'
import { Container } from 'react-grid-system'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Spinner, Dialog, Classes, Button } from '@blueprintjs/core'
import { DatePicker } from '@blueprintjs/datetime'
import Schedule from './schedule'
import TopBar from '../layout/top-bar/top-bar'
import Footer from '../layout/footer/footer'
import Login from '../login/login'

import { patientsApi } from '../../api'
import { serverErrorToast, errorToast, successToast } from '../layout/toaster/toaster'
import { packScheduleThrifty28days, packScheduleJones7days } from '../../config/defaultSchedules'

import css from './patient.module.css'

function Patient () {
  const [users, setUsers] = useState([])
  const [patient, setPatient] = useState()
  const [isStartDateDialogOpen, setStartDateDialogOpen] = useState(false)
  const [startDate, setStartDate] = useState()
  const [rxId, setRxId] = useState('')
  const [clientId, setClientId] = useState('')

  const fetchData = async () => {
    try {
      if (!rxId || !clientId) {
        return errorToast('Pharmacy ID and Clinet ID can not be empty')
      }

      setPatient(false)
      const { data } = await patientsApi.get(`rx/${rxId}/${clientId}`)
      if (!data.subscriptionStartDate) {
        setStartDateDialogOpen(true)
      }

      // Support more types of packs and default to 7 days if nothing is found
      if ((!data.packType || data.packType === 'jones7days') && !data.packSchedule?.weeks) {
        data.packSchedule = packScheduleJones7days
      } else if ((!data.packType || data.packType === 'us_7days') && !data.packSchedule?.weeks) {
        data.packSchedule = packScheduleJones7days
      } else if ((!data.packType || data.packType === 'ca_7days') && !data.packSchedule?.weeks) {
        data.packSchedule = packScheduleJones7days
      } else if ((!data.packType || data.packType === 'us_dispill') && !data.packSchedule?.weeks) {
        data.packSchedule = packScheduleJones7days
      } else if (data.packType === 'thrifty28days' && !data.packSchedule?.packs) {
        data.packSchedule = packScheduleThrifty28days
      } else {
        data.packSchedule = packScheduleJones7days
      }

      if (data.version === 'v3') {
        const userData = await patientsApi.get(`rx/users/${data._id}`)
        if (userData.data) {
          setUsers(userData.data.users)
        } else {
          setUsers([])
        }
      } else {
        setUsers([])
      }

      setPatient(data)
    } catch (err) {
      setPatient(null)
      setUsers([])
      serverErrorToast(err, true)
    }
  }

  const createParticipant = async (body) => {
    const bodyData = {
      firstName: body.firstName,
      lastName: body.lastName,
      name: body.firstName + body.lastName,
      email: body.email,
      patientId: body.patientId,
      type: 'patient',
      // organizationId: body.organizationId,
      // organizationName: body.organizationName,
      password: body.password
    }

    if (!bodyData.email) {
      alert('Email is missing')
      return
    }

    if (!bodyData.password || bodyData.password.length < 8) {
      alert('Password must be at least 8 characters')
      return
    }

    try {
      const { data } = await patientsApi.post('rx/users', bodyData)
      let successText = 'Successfuly created gateway user ' + bodyData.firstName + ' ' + bodyData.lastName
      if (!data) {
        successText = 'Failed to create user ' + bodyData.firstName + ' ' + bodyData.lastName
      }
      alert(successText)

      const userData = await patientsApi.get(`rx/users/patients/${patient._id}`)
      setUsers(userData.users)
    } catch (error) {

    }
  }

  const deleteParticipant = async (u) => {
    try {
      let successText = 'Successfully removed user ' + u.firstName + ' ' + u.lastName
      const { data } = await patientsApi.post('users/deleteUser', { userId: u._id })
      if (!data) {
        successText = 'Failed to delete user ' + u.firstName + ' ' + u.lastName
      }
      alert(successText)
      const userData = await patientsApi.get(`users/${data.patientId}`)
      setUsers(userData.data)
    } catch (error) {
      const errorText = 'Failed to delete user ' + u.firstName + ' ' + u.lastName
      alert(errorText)
    }
  }

  const saveAssignParticipant = async (body) => {
    let errorText = 'Failed to assign participant with StickerId:' + body.stickerId + ', recordId:' + body.recordId + '.  Please ensure the pack is activated and assigned to the Sticker Id.  Please contact CuePath for further assistance.'
    try {
      setPatient(false)

      const bodyData = {
        stickerId: body.stickerId,
        recordId: body.recordId,
        event: body.event,
        patientId: body.patientId,
        repeatInstanceId: body.repeatInstanceId
      }

      if (bodyData.stickerId === '' || bodyData.recordId === '') {
        errorText = 'Failed to assign participant.  Please ensure stickerId and recordId are valid entries'
        alert(errorText)
        errorToast(errorText)
        return
      }

      const { data } = await patientsApi.post('rx/setParticipantInfo', bodyData)
      if (data) {
        const successText = 'Successfuly assigned participant with StickerId:' + body.stickerId + ' RecordId:' + bodyData.recordId + ' EventName:' + bodyData.event + ' repeatInstanceId:' + bodyData.repeatInstanceId
        alert(successText)
        successToast(
          successText
        )
      } else {
        alert(errorText)
        errorToast(errorText)
      }
    } catch (err) {
      alert(errorText)
      errorToast(errorText)
      setPatient(null)
    } finally {
      setPatient(body.patient)
    }
  }

  const savePatient = async (body) => {
    try {
      setPatient(false)
      const { data } = await patientsApi.patch(`rx/${rxId}/${clientId}`, body)
      setPatient(data)
      successToast(
        'The schedule was successfully updated. If you made changes to current week, it will be applied tomorrow.'
      )
    } catch (err) {
      setPatient(null)
      serverErrorToast(err)
    }
  }

  return (
    <>
      <TopBar
        users={users}
        patient={patient}
        rxId={rxId}
        setRxId={setRxId}
        clientId={clientId}
        setClientId={setClientId}
        fetchData={fetchData}
      />
      <Container style={{ maxWidth: 1200 }} className={css.content}>
        <Switch>
          {patient === false && <Spinner />}
          <Route path="/login">
            {patient && <Redirect to="/" />}
            <Login rxId={rxId} setRxId={setRxId} clientId={clientId} setClientId={setClientId} fetchData={fetchData} />
          </Route>
          <Route path="/">
            {patient ? <Schedule patient={patient} users={users} savePatient={savePatient} saveAssignParticipant={saveAssignParticipant} createParticipant={createParticipant} deleteParticipant={deleteParticipant}/> : <Redirect to="/login" />}
          </Route>
        </Switch>
      </Container>
      <Footer />
      <Dialog
        icon="info-sign"
        title="Prescription Start Date"
        isOpen={isStartDateDialogOpen}
        isCloseButtonShown={false}
      >
        <div className={Classes.DIALOG_BODY}>
          <p>
            <strong>
              Please set prescription start date for this patient, specifying when the first pack should be started.
            </strong>
          </p>
          <div style={{ alignItems: 'center', flexDirection: 'column', display: 'flex' }}>
            <DatePicker
              className={Classes.ELEVATION_1}
              onChange={(v) => setStartDate(v)}
              maxDate={moment().add(12, 'month').toDate()}
            />
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button
              onClick={() => {
                savePatient({ ...patient, subscriptionStartDate: startDate })
                setStartDateDialogOpen(false)
              }}
            >
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default Patient
